export default "__VITE_ASSET__CCutZq_p__"